const f="undefined"!=typeof Symbol&&"function"==typeof Symbol.for?Symbol.for("amplify_default"):"@@amplify_default";export{f as AMPLIFY_SYMBOL};
